/**
 * Animation timing constants for the score animation sequence
 */
export const ANIMATION_TIMINGS = {
  /** Delay before first animation starts */
  INITIAL_DELAY_MS: 400,
  /** Duration of score counter tick animation for initial line items */
  NORMAL_SCORE_ANIMATION_DURATION_MS: 600,
  /** Duration of score counter tick animation when applying a credit */
  APPLY_CREDIT_SCORE_ANIMATION_DURATION_MS: 1600,
  /** Delay between multiple score changes */
  BETWEEN_CHANGES_DELAY_MS: 600,
} as const;
